import { WorldpayIframeFormValue } from '../../models/worldpay/worldpay-iframe-form-value.interface';

export const mockWorldpayIframeFormValue: WorldpayIframeFormValue = {
  cardNumber: '4444 3333 2222 1111',
  cardHolderName: 'Any Name',
  cardExpiryMonth: 12,
  cardExpiryYear: 30,
  cardSecurityCode: '123',
};
